import React from "react";
import {BaseThatsMeIconProps} from "../../interfaces/baseThatsMeIconProps.interface";
import {useTheme} from "@mui/material";

export default (props: BaseThatsMeIconProps) => {
    const theme = useTheme();
    const {size = 24, fill= theme.palette.thatsMe.iconsDefault, ...rest} = props;
    return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M8.45523 10.5074L7.0724 8.12327L2.94778 10.5074L2.05371 8.96965L7.73997 5.69141L9.11088 8.07558L13.2474 5.69141L14.6183 8.07558L18.7549 5.69141L21.0198 9.61338L19.4701 10.5074L18.0873 8.12327L13.9627 10.5074L12.5799 8.12327L8.45523 10.5074ZM8.45523 18.1368L7.0724 15.7526L2.94778 18.1368L2.05371 16.599L7.73997 13.3208L9.11088 15.7049L13.2474 13.3208L14.6183 15.7049L18.7549 13.3208L21.0198 17.2427L19.4701 18.1368L18.0873 15.7526L13.9627 18.1368L12.5799 15.7526L8.45523 18.1368Z"
            fill={fill}/>
    </svg>
}
